<template>
	<div>
		<div class="row">
			<div class="col-md-12 p-0">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>JBT</strong></span>
					</div>
					<div>
						<div class="mb-3" style="margin-top:-21px;">   
							<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<FuelJBTTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>	
			</div>
		</div>
	</div>
</template>

<script>

import Fuel from '@/components/page/Fuel.js'
import FuelJBTTab from '@/views/pages/FuelJBTTab.vue'

export default
{
	extends: Fuel,
	components: { 
		FuelJBTTab,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '2', 
			tabList:[
				//{label:'Transaction Base on Vehicle No', name: 'vehicle_transaction', index: '0' },
				//{label:'Hose Delivery Transaction', name: 'delivery_transaction', index: '1' },
				{label:'Monitoring Sales Volume', name: 'sales_volume', index: '2' },
				{label:'Monitoring Trans Count', name: 'trans_count', index: '3' },
				{label:'Latest Transaction', name: 'latest_transaction', index: '4' },
			],
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>